import { Link } from "react-router-dom";
import { Alert } from "@/components/ui/Alert";
import type { Order } from "@/lib/projects";
import {
  PROJECT_KORREKTUR_FALLTYP_LABELS,
  projectDetailPath,
  type ProjectKorrekturFalltyp,
} from "@/lib/projectKorrektur";

function falltypLabel(value: string | null | undefined): string | null {
  if (!value) return null;
  return PROJECT_KORREKTUR_FALLTYP_LABELS[value as ProjectKorrekturFalltyp] || value;
}

export function ProjectKorrekturBanner({ project }: { project: Order }) {
  const mergedIntoId = project.merged_into_auftrag_id;
  const mergedIntoNummer = project.merged_into_auftragsnummer || `#${mergedIntoId}`;
  const sources = project.korrektur_quellen || [];

  if (mergedIntoId) {
    const label = falltypLabel(project.korrektur?.falltyp);
    return (
      <Alert variant="warning" title="Verweisakte — nicht mehr verwenden" className="mb-3">
        <p>
          Dieses Projekt wurde nach{" "}
          <Link
            className="font-semibold text-accent underline-offset-2 hover:underline"
            to={projectDetailPath(mergedIntoId)}
          >
            {mergedIntoNummer}
          </Link>{" "}
          zusammengeführt. Neue Stunden, Bestellungen und Angebote gehören dorthin.
          {label ? ` Falltyp: ${label}.` : ""} Die alte Nummer bleibt auffindbar.
        </p>
      </Alert>
    );
  }

  if (sources.length > 0) {
    return (
      <Alert variant="info" title="Führende Akte nach Zusammenführung" className="mb-3">
        <p>
          Hierhin überführt:{" "}
          {sources.map((source, index) => (
            <span key={`${source.auftrag_id}-${index}`}>
              {index > 0 ? ", " : null}
              <Link
                className="font-semibold text-accent underline-offset-2 hover:underline"
                to={projectDetailPath(source.auftrag_id)}
              >
                {source.auftragsnummer || `#${source.auftrag_id}`}
              </Link>
            </span>
          ))}
          . Alte Nummern bleiben als Verweisakte sichtbar.
        </p>
      </Alert>
    );
  }

  return null;
}
